/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import clsx from "clsx";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import DialogChangePassword from "./components/DialogChangePassword";

import {
	logoutRequest,
	changePasswordRequest,
	onLoginWithFaceIdAction,
	offLoginWithFaceIdAction
} from "store/actions/LoginPageAction";
import { getValidateLoginFaceIdAction } from "store/actions/GlobalAction";
import { Grid, Button, TextField } from "@material-ui/core";
import { Controller, useForm } from "react-hook-form";
import { getIsApp } from "config/constant";
import { Images } from "config/images";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { SKIP_CHANGE_PASSWORD } from "config/constant";

const ErrorOldPass = ({ error, messageChangePassword }) => {
	const classes = useStyles();
	return error ? (
		<Grid classes={{ root: classes.textError }}>
			{error?.type === "required" && "Vui lòng nhập mật khẩu hiện tại."}
		</Grid>
	) : messageChangePassword?.statusCode === -1033 ? (
		<Grid classes={{ root: classes.textError }}>
			{messageChangePassword?.message}
		</Grid>
	) : (
		""
	);
};

const matches = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%?<>~|{}^&*()_+])/;

const ErrorNewPass = ({ error }) => {
	const classes = useStyles();
	return error ? (
		<React.Fragment>
			{error?.type === "required" && (
				<Grid classes={{ root: classes.textError }}>
					Vui lòng nhập mật khẩu mới.
				</Grid>
			)}
			{(error?.type === "all" ||
				(error?.type === "validate" && error?.message === "all")) && (
				<React.Fragment>
					<Grid classes={{ root: classes.textNotiError }}>
						<CancelRoundedIcon /> Sử dụng tối thiểu 8 ký tự
					</Grid>
					<Grid classes={{ root: classes.textNotiError }}>
						<CancelRoundedIcon />
						Bao gồm số, chữ thường, chữ in hoa và ký tự đặc biệt
					</Grid>
				</React.Fragment>
			)}
			{(error?.type === "minLength" ||
				(error?.type === "validate" &&
					error?.message === "minLength")) && (
				<React.Fragment>
					<Grid classes={{ root: classes.textNotiError }}>
						<CancelRoundedIcon /> Sử dụng tối thiểu 8 ký tự
					</Grid>
					<Grid classes={{ root: classes.textNotiSuccess }}>
						<CancelRoundedIcon />
						Bao gồm số, chữ thường, chữ in hoa và ký tự đặc biệt
					</Grid>
				</React.Fragment>
			)}
			{(error?.type === "pattern" ||
				(error?.type === "validate" &&
					error?.message === "pattern")) && (
				<React.Fragment>
					<Grid classes={{ root: classes.textNotiSuccess }}>
						<CheckCircleRoundedIcon />
						Sử dụng tối thiểu 8 ký tự
					</Grid>
					<Grid classes={{ root: classes.textNotiError }}>
						<CancelRoundedIcon /> Bao gồm số, chữ thường, chữ in hoa
						và ký tự đặc biệt
					</Grid>
				</React.Fragment>
			)}
		</React.Fragment>
	) : (
		<React.Fragment>
			<Grid classes={{ root: classes.textNoti }}>
				Sử dụng tối thiểu 8 ký tự
			</Grid>
			<Grid classes={{ root: classes.textNoti }}>
				Bao gồm số, chữ thường, chữ in hoa và ký tự đặc biệt
			</Grid>
		</React.Fragment>
	);
};

const ErrorConfirmNewPass = ({ error, messageChangePassword }) => {
	const classes = useStyles();
	return error ? (
		<Grid classes={{ root: classes.textError }}>
			{error?.type === "required" && "Vui lòng xác nhận mật khẩu."}
			{error?.type === "validate" &&
				"Mật khẩu không khớp.Vui lòng nhập lại"}
		</Grid>
	) : messageChangePassword.statusCode === -1026 ? (
		<Grid classes={{ root: classes.textError }}>
			{messageChangePassword?.message}
		</Grid>
	) : (
		""
	);
};

const ChangePasswordPage = props => {
	const classes = useStyles();
	const {
		changePassword,
		getValidateLoginFaceId,
		infoShop,
		messageChangePassword,
		logout
	} = props;

	const history = useHistory();

	const passwordType = infoShop?.passwordType;

	useEffect(() => {
		getValidateLoginFaceId();
	}, []);

	const [checkPass, setCheckPass] = useState({
		password: false,
		newPassword: false,
		reNewPassword: false
	});

	const {
		handleSubmit,
		control,
		setError,
		clearErrors,
		setValue,
		getValues,
		formState: { errors }
	} = useForm();

	const isApp = getIsApp();
	const [dataModalConfirmChangePassword, setDataModalConfirmChangePassword] =
		useState({
			isOpen: false,
			statusCode: -1,
			message: ""
		});

	const onConfirm = data => {
		setDataModalConfirmChangePassword({
			isOpen: true,
			statusCode: data?.statusCode,
			message: data?.message
		});
	};

	const onSubmit = data => {
		const { password, newPassword } = data;
		const body = {
			oldPassword: password,
			newPassword: newPassword,
			onConfirm
		};
		changePassword(body);
	};

	const handleClickShowPassword = type => {
		setCheckPass({ ...checkPass, [type]: !checkPass[type] });
	};

	const validateNewPasswordError = value => {
		setValue("newPassword", value);
		if (!matches.test(value) && value.length >= 8) {
			setError("newPassword", {
				type: "pattern",
				message: ""
			});
		} else if (matches.test(value) && value.length < 8) {
			setError("newPassword", {
				type: "minLength",
				message: ""
			});
		} else if (!matches.test(value) && value.length < 8) {
			setError("newPassword", {
				type: "all",
				message: ""
			});
		} else {
			clearErrors("newPassword");
		}
	};

	const validateReNewPassError = value => {
		setValue("reNewPassword", value);
		const newPassword = getValues("newPassword");
		if (value.length === 0) {
			setError("reNewPassword", {
				type: "required",
				message: ""
			});
		} else if (value !== newPassword) {
			setError("reNewPassword", {
				type: "validate",
				message: ""
			});
		} else {
			clearErrors("reNewPassword");
		}
	};

	const validateReNewPassErrorSubmit = value => {
		const newPassword = getValues("newPassword");
		if (value !== newPassword) {
			return "validate";
		} else {
			return true;
		}
	};

	const validateNewPasswordErrorSubmit = value => {
		if (!matches.test(value) && value.length >= 8) {
			return "pattern";
		} else if (matches.test(value) && value.length < 8) {
			return "minLength";
		} else if (!matches.test(value) && value.length < 8) {
			return "all";
		} else {
			return true;
		}
	};

	const handleLogout = () => {
		localStorage.clear();
		if (typeof window !== undefined && isApp) {
			window?.ReactNativeWebView?.postMessage("LOGOUT");
		} else {
			logout();
		}
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.rootForm }}>
				<Grid classes={{ root: classes.iconChangePass }}>
					<img
						src={Images.changePassword}
						alt={"changePassword"}
						width={150}
					/>
				</Grid>
				<Grid classes={{ root: classes.textInfo }}>
					{infoShop?.passwordChangeNotification}
				</Grid>
				<form onSubmit={handleSubmit(onSubmit)}>
					<Grid classes={{ root: classes.title }}>
						Mật khẩu hiện tại
					</Grid>
					<Controller
						control={control}
						name="password"
						rules={{
							required: true
						}}
						render={({ field }) => (
							<Grid>
								<TextField
									{...field}
									type={
										checkPass.password ? "text" : "password"
									}
									InputProps={{
										endAdornment: checkPass.password ? (
											<Visibility
												onClick={() =>
													handleClickShowPassword(
														"password"
													)
												}
											/>
										) : (
											<VisibilityOff
												onClick={() =>
													handleClickShowPassword(
														"password"
													)
												}
											/>
										)
									}}
									className={clsx(
										classes.customInput,
										errors?.password
											? classes.inputError
											: ""
									)}
								/>
								<ErrorOldPass
									error={errors?.password}
									messageChangePassword={
										messageChangePassword
									}
								/>
							</Grid>
						)}
					/>
					<Grid classes={{ root: classes.title }}>Mật khẩu mới</Grid>
					<Controller
						control={control}
						name="newPassword"
						rules={
							("newPassword",
							{
								required: true,
								validate: validateNewPasswordErrorSubmit
							})
						}
						render={({ field }) => (
							<Grid>
								<TextField
									{...field}
									type={
										checkPass.newPassword
											? "text"
											: "password"
									}
									InputProps={{
										endAdornment: checkPass.newPassword ? (
											<Visibility
												onClick={() =>
													handleClickShowPassword(
														"newPassword"
													)
												}
											/>
										) : (
											<VisibilityOff
												onClick={() =>
													handleClickShowPassword(
														"newPassword"
													)
												}
											/>
										)
									}}
									onChange={e => {
										const value = e.target.value;
										validateNewPasswordError(value);
									}}
									className={clsx(
										classes.customInput,
										errors?.newPassword
											? classes.inputError
											: ""
									)}
								/>
								<ErrorNewPass error={errors.newPassword} />
							</Grid>
						)}
					/>
					<Grid classes={{ root: classes.title }}>
						Nhập lại mật khẩu
					</Grid>
					<Controller
						control={control}
						name="reNewPassword"
						rules={
							("reNewPassword",
							{
								required: true,
								validate: validateReNewPassErrorSubmit
							})
						}
						render={({ field }) => (
							<Grid>
								<TextField
									{...field}
									type={
										checkPass.reNewPassword
											? "text"
											: "password"
									}
									onChange={e => {
										const value = e.target.value;
										validateReNewPassError(value);
									}}
									InputProps={{
										endAdornment:
											checkPass.reNewPassword ? (
												<Visibility
													onClick={() =>
														handleClickShowPassword(
															"reNewPassword"
														)
													}
												/>
											) : (
												<VisibilityOff
													onClick={() =>
														handleClickShowPassword(
															"reNewPassword"
														)
													}
												/>
											)
									}}
									className={clsx(
										classes.customInput,
										errors?.reNewPassword
											? classes.inputError
											: ""
									)}
								/>
								<ErrorConfirmNewPass
									error={errors.reNewPassword}
									messageChangePassword={
										messageChangePassword
									}
								/>
							</Grid>
						)}
					/>
					<Grid classes={{ root: classes.bodyBtnSubmit }}>
						<Button
							type="submit"
							classes={{ root: classes.btnSubmit }}
						>
							Lưu
						</Button>
						{SKIP_CHANGE_PASSWORD.includes(passwordType) && (
							<Button
								variant="outlined"
								classes={{ root: classes.btnCancel }}
								onClick={() => {
									history.push("/home");
									localStorage.setItem(
										"isSkipChangePassword",
										true
									);
								}}
							>
								Bỏ qua
							</Button>
						)}
					</Grid>
				</form>
			</Grid>
			<DialogChangePassword
				open={dataModalConfirmChangePassword.isOpen}
				handleClose={() => {
					handleLogout();
				}}
			/>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		isLoginFaceId: state.globalReducer.isLoginFaceId,
		infoShop: state.homePageReducer.infoShop,
		messageChangePassword: state.globalReducer.messageChangePassword
	};
};

const mapDispatchToProps = dispatch => {
	return {
		changePassword: data => {
			dispatch(changePasswordRequest(data));
		},
		onLoginWithFaceId: data => {
			dispatch(onLoginWithFaceIdAction(data));
		},
		offLoginWithFaceId: data => {
			dispatch(offLoginWithFaceIdAction(data));
		},
		getValidateLoginFaceId: () => {
			dispatch(getValidateLoginFaceIdAction());
		},
		logout: () => {
			dispatch(logoutRequest());
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordPage);
